import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const HelpNavigationPanel = ({ categories, selectedCategory, onCategorySelect }) => {
  const categoryIcons = {
    'all': 'Grid',
    'png-employment-act': 'Scale',
    'nasfund-compliance': 'Shield',
    'swt-processing': 'Calculator',
    'department-workflows': 'Workflow',
    'executive-dashboard': 'BarChart3',
    'payroll-compliance': 'DollarSign',
    'leave-management': 'Clock',
    'dlir-filing': 'FileText',
    'pacific-rbs': 'CreditCard'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 sticky top-32">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Compass" size={20} color="var(--color-primary)" />
        Help Categories
      </h3>
      <nav className="space-y-1">
        {categories?.map((category) => (
          <button
            key={category?.value}
            onClick={() => onCategorySelect(category?.value)}
            className={cn(
              'w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-smooth text-left',
              selectedCategory === category?.value
                ? 'bg-primary text-primary-foreground font-medium'
                : 'text-foreground hover:bg-muted'
            )}
          >
            <Icon 
              name={categoryIcons?.[category?.value] || 'Circle'} 
              size={18} 
              color={selectedCategory === category?.value ? 'var(--color-primary-foreground)' : 'currentColor'}
            />
            <span className="flex-1">{category?.label}</span>
          </button>
        ))}
      </nav>

      {/* Quick Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-semibold text-foreground mb-3">Quick Stats</h4>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Total Tutorials</span>
            <span className="font-semibold text-foreground">9</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Video Guides</span>
            <span className="font-semibold text-foreground">8</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Documents</span>
            <span className="font-semibold text-foreground">1</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpNavigationPanel;